import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faGithub, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import { personnel, values } from "../../_helpers/mock-data";
import { Footer } from "../../components/footer/footer";
import { Header } from "../../components/header/header";
import SlideRight from "../../components/utilities/right-shift";
import "../../styles/personnel.css";
import InViewPort from "../../components/utilities/in-viewport";



export const PersonnelPage = () => {
    const cntr = Array(3).fill("h", 0, 3)
    return (
        <div className="rand-page">
            <Header pageTitle={"Personnel"} />
            <div style={{ marginTop: 150 }} />
            <div className="serv-title flx-rw-c">
                <span className="norm-text">Meet Our</span>
                <span style={{ width: 8 }} />
                <span className="gradient-text">Expert Team</span>
            </div>
            <div className="dev-text">
                Brilliant minds driving innovation in AI-assisted technology solutions. Our diverse team combines deep expertise with cutting-edge AI knowledge.
            </div>
            <div className="services-box">
                {personnel.map((process, indx) => (
                    <SlideRight key={indx}>
                        <div className="process-unit">
                            <div className="bl-bg gen-proc-circle">
                                <FontAwesomeIcon icon={process.icon} />
                            </div>
                            <div className="process-caption">{process.caption}</div>
                            <div className="process-descr">{process.descr}</div>
                        </div>
                    </SlideRight>
                ))}
            </div>
            <InViewPort>
                <div className="page-sub-cap">
                    <span className="gradient-text">Our</span>
                    <span className="norm-text">Leadership Team</span>
                </div>
            </InViewPort>
            <div className="members-container">
                {cntr.map(() => (
                    <div className="member-unit glassy-effect">
                        <div className="member-avatar">
                            <img src="/images/ngu_alph.png" alt="" className="member-img" />
                        </div>
                        <div className="member-caption">Ngu Alpha T.</div>
                        <div className="skill-summary">
                            Web development 6+ years. Mobile development 4+ years.
                        </div>
                        <div className="member-details">
                            Senior developer with sound experience in building leading edge mobile, desktop and web applications.
                        </div>
                        <div className="skills-container">
                            <div className="skill-unit">Node Js</div>
                            <div className="skill-unit">Laravel</div>
                            <div className="skill-unit">PHP</div>
                            <div className="skill-unit">React/Next Js</div>
                            <div className="skill-unit">AWS</div>
                        </div>
                        <div className="soc-icons">
                            <button className="soc-btn tr-btn">
                                <FontAwesomeIcon icon={faEnvelope} className="soc-icon" />
                            </button>
                            <button className="soc-btn tr-btn">
                                <FontAwesomeIcon icon={faGithub} className="soc-icon" />
                            </button>
                            <button className="soc-btn tr-btn">
                                <FontAwesomeIcon icon={faLinkedinIn} className="soc-icon" />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            <InViewPort>
                <div className="page-sub-cap">
                    <span className="gradient-text">Our</span>
                    <span className="norm-text">Culture & Values</span>
                </div>
            </InViewPort>
            <div className="services-box">
                {values.map((process, indx) => (
                    <SlideRight key={indx}>
                        <div className="process-unit">
                            <div className="bl-bg gen-proc-circle">
                                <FontAwesomeIcon icon={process.icon} />
                            </div>
                            <div className="process-caption">{process.caption}</div>
                            <div className="process-descr">{process.descr}</div>
                        </div>
                    </SlideRight>
                ))}
            </div>
            <InViewPort>
                    <div className="offer-bx glassy-effect">
                        <div className="q-cap">
                            <span className="norm-text of-cap">Join Our </span>
                            <span className="gradient-text of-cap">Amazing Team</span>
                        </div>
                        <div className="descr">
                            Ready to shape the future of AI-assisted technology? We're always looking for brilliant minds to join our mission.
                        </div>
                       <div className="descr-btns" style={{justifyContent: "center"}}>
                            <button
                                className="descr-btn st-btn bt-bl-bg"
                                style={{ backgroundImage: `linear-gradient(to bottom right, #5c7ce4ff, #600c70ff`, minWidth: 200, fontSize: 18 }}
                            >
                                <span className="btn-cap">View Open Positions</span>
                            </button>
                            <button className="descr-btn st-btn bt-blk-bg" style={{minWidth: 200, fontSize:18}}>
                                <span className="btn-cap">Submit Your Resume</span>
                            </button>
                        </div>

                    </div>
                
            </InViewPort>
            <Footer />
        </div>
    )
}